// 能够手动修改学校官网配置的学校id列表
export const expWebConfigList = ["49538854775951360"]
